import React from 'react';
import "./Navbar2.css";
import { Link } from 'react-router-dom';
import remove from "../Images/remove.png"



const Navbar = () => {
    return (
      <div className='nav22'>
            <Link exact to="/" className="nav-link" activeClassName="active">
            <img src={remove} alt="Back" className="logo" />
            </Link>
            <nav2>
            <ul>
            <div className='right12'>
            <li><Link to="/About"> &nbsp;&nbsp; About &nbsp;&nbsp; </Link></li>
              <li><Link to="/FFaq"> &nbsp;&nbsp; FAQ &nbsp;&nbsp;</Link></li>
              <li><a href="Help">&nbsp;&nbsp; Help &nbsp;&nbsp;</a></li>
            </div>
            <div className='right22'>
            
            <li><Link to="/Signup" className="signup">&nbsp; Sign up &nbsp;</Link></li>
            <li><Link to="/Login" className="login">&nbsp; Login &nbsp;</Link></li>
            
            </div>
              
            </ul>
            </nav2>
          </div>
    )
  }
  
  export default Navbar
  







